import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ApplicableTableSettings, codesRegionCountryList } from '../../../../tableSettings';

import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../../../ApplicationContext';
import { Search, isFilterObjectEmpty, getInitialSearch } from '../../../../filtering';
import { Portal } from 'react-portal';
import { JobNames } from '../../../../framework.core/JobNames';
import { CodeCountryListItem } from '../../../../fms.data/models/CodeCountryListItem';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import GreenButton from '../../../../ui/GreenButton';
import EditableTable, { CellData, TableCellAligns, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import TextBox from '../../../../ui/TextBox';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import { duplicateCell, findSecurityTask } from '../../../../util';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";

import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import { RefreshIconButton2 } from '../../../../ui/IconButton';

class EditableCodeCountryInfoListItem extends CodeCountryListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
}

// function ActionRenderer({ data, row }: any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew && data[row.index].listSec?.grantDel &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }

function IsoCodeRenderer({data, row, cell}: any) {
  // useEffect(() => {
  //   const focusElement = document.getElementById('ifms-isocode') as HTMLInputElement;
  //   if (focusElement) {
  //     focusElement.focus();
  //     focusElement.select();
  //   }
  // },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );
    const changeLineItem = data[0].changeLineItem;
    const l = data[row.index];
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-isocode-${row.index}`} maxLength={2} value={l.isoCode} onChange={(e) => {
          changeLineItem(row.index,{isoCode: e.target.value, isUpdate:true });
          }} />
      </div>
    );
}

function CountryNameRenderer({data, row, cell}: any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-name-${row.index}`} maxLength={50} value={l.countryName} onChange={(e) => {
        changeLineItem(row.index,{countryName: e.target.value, isUpdate:true});
          }} />
      </div>
    );
}

function UsCodeRenderer({data, row, cell}: any) {
    const changeLineItem = data[0].changeLineItem;
    const l = data[row.index];
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-uscode-${row.index}`}  maxLength={6} value={l.usCode} onChange={(e) => {
          changeLineItem(row.index,{usCode: e.target.value, isUpdate:true});
          }}
        />
      </div>
    );
}

function formatElement(data: any) {
  const result = new EditableCodeCountryInfoListItem();
  result.isoCode = data.isoCode;
  result.countryName = data.countryName;
  result.usCode = data.usCode;
  result.cid = data.cid;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function CountryComponent({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
  }});
  useFunctionKeys({ onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);

  const [showGlobalOkDialog] = useGlobalOkDialog();

  const savedDataRef = useRef<Array<CodeCountryListItem>>([]);
  const oriData = useRef<CodeCountryListItem[]>([]);

  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-region-country-list`, []);
  //const [ei, setEi, , ediRef] = useFastStorage(`ifms-referenceFiles-region-country-editindex`, -1);
  const [orderBy, setOrderBy] = useTypedFastStorage<ListOrderBy>(`ifms-referenceFiles-region-country-orderby`, getDefaultOrderBy());
  //const addingToTheFirstLine = useRef(false);

  const listSec = findSecurityTask(appContext, FmsSecTask.CodeCountry);

  const tableHeight = 520;
  const listItemType = 'CodeCountryListItem';

  const [focusFirstCell, setFocusFirstCell] = useState({ dataLength: 0, focus: false });
  const { FilterButton, search } = useFilterBar(
    codesRegionCountryList,
    undefined,
    getDefaultOrderBy(), 
    String(componentIndex),
    false,
    undefined,
    undefined,
    setOrderBy,
  );

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'isoCode',
      orderByAscending: true,
    };
  }

  function setData(d: any, callByFetchData: boolean = false) {
    setFocusFirstCell({ dataLength: d.length, focus: callByFetchData });
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeCountryListItem, oriData.current, d));
  }

  async function fetchData(api: any, clearHeaderOrder: boolean) {
    if (clearHeaderOrder && isFilterObjectEmpty(search)) {
      setOrderBy(getDefaultOrderBy());
    } else if (search.orderBy) {
      setOrderBy({ orderBy: search.orderBy, orderByAscending: search.orderByAscending });
    }

    setLoading(true);
    const apiResult = await api.getListItems(JobNames.Country,
      listItemType,
      CodeCountryListItem.calculateSearchParameters(search),
      1,
      search.pageSize);
    const data = apiResult && apiResult.entities ? apiResult.entities : [];

    setData(formatData(data), true);

    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);
    
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, isFilterObjectEmpty(search));
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function reload(clearAll:boolean = true) {
    await fetchData(appContext.api, clearAll);
  }

  // async function requestOperationCancel() {
  //   const doCancel = await showGlobalYesNoDialog(<p>Are you sure you want to cancel Edit operation</p>);
  //   if (doCancel) {
  //     cancelOperation(false)
  //   } else {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80);
  //   }
  // }

  // async function onRowIndexChanged(rowIndex: number) {
  //   if (rowIndex < 0 && ediRef.current >= 0) {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80)
  //     return;
  //   }

  //   if (ediRef.current >= 0 && ediRef.current !== rowIndex) {
  //     await requestOperationCancel();
  //   }
  // }

  // function onRowSelect(rowIndex: number) {
  //   if (rowIndex >= 0 && rowIndex < dataRef.current.length && _.isEmpty(inlineElement) && (listSec?.grantEdit || listSec?.grantDel)) {
  //     setHasChanges(true);
  //     inlineElement = {...dataRef.current[rowIndex], isNew: false};
  //     setEi(rowIndex);
  //   }
  // }

  // function selectForNew() {
  //   inlineElement = {
  //     isoCode: '', countryName: '', usCode: '', isNew: true,
  //   };
  //   data.unshift(inlineElement);
  //   setData(data);
  //   setEi(0);
  //   setHasChanges(true);
  // }

  async function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }

  

  function addLineItem() {
    const newRow = new EditableCodeCountryInfoListItem();
    newRow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newRow
    };
  }

  function applyToLineItem(rowIndex: number, change: Partial<EditableCodeCountryInfoListItem> | null) {
    if (!change || !data) {
      return;
    }
    const checkData = data[rowIndex];

    if (!change.isNew && (change.isoCode !== checkData.isoCode || change.countryName !== checkData.countryName || change.usCode !== checkData.usCode)) {
      _.merge(data[rowIndex], { ...change, hasBeenChanged: true });
      setData(data);
      //setHasChanges(true);
    }
    return true;
  }



  function deleteEntity(index: number): boolean {
    if (!data) {
      return false;
    }

    const element = data[index];
    if (!element.isNew) {
      let deleteRow = savedDataRef.current.find(x => x.countryName === element.countryName);
      if (deleteRow) {
        deleteRow.isDelete = true;
        //setHasChanges(true);
      }
    }
    data.splice(index, 1);
    setData(data);
    return true;
  }


  async function save() {
    if (!data) {
      return;
    }

    let validData = dataRef.current.filter((x:any) => x.isoCode && x.countryName);

    let errMsg = '';
    const dataToSave = validData.filter((x:any, i:number) => x.isNew || x.hasBeenChanged === true);
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload(false);
      return;
    }
    setLoading(true);
  
    for(let i = 0; i < dataToDelete.length; ++i){
      const s = dataToDelete[i];
      const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
       if(!apiResult || !apiResult.success)
         errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
    }
  
    if(dataToSave.length > 0){
      const isDuplicate = await duplicateCell(dataToSave, data, appContext, listItemType, showGlobalOkDialog, JobNames.Country, 'countryName');
      if(isDuplicate){
        setLoading(false);
        return;
      }

      const apiResult:ApiResult<InsertResult> = await appContext.api.saveList(listItemType,
          dataToSave);


      if(!apiResult || !apiResult.success){
        errMsg += (errMsg ? '\n' : '' ) + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
      }
      
      if(errMsg) {
        await showGlobalOkDialog(<p>{errMsg}</p>);
        setLoading(false);
        return;
      }
    
    
      dataToSave.forEach((x:any) => {
        const index = data.findIndex((d: any) => d.countryName === x.countryName);
        if(index >= 0){
          data[index].cid = x.countryName;
          data[index].hasBeenChanged = false;
        }
        if(x.isNew){
          delete data[index].isNew;
        }
      })
    }
 
    //  setData(data);
    //  savedDataRef.current = _.cloneDeep(data);
    //  oriData.current = _.cloneDeep(data);
  
    // setLoading(false);
    // setHasChanges(false);
    reload(false);

    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  function onHeaderClick(header: any) {
    if (!orderBy || !orderBy.orderBy) return;

    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
      
      removeData();
      sortingListData(CodeCountryListItem, data, setData, orderBy);
    }
  }

  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-region-country-list',
    selectable: true,
    tableName: 'regionCountryList',
    ...codesRegionCountryList,
    height: `${tableHeight}px`,
    // data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges, requestOperationCancel, listSec})),
    data: data.map((x:any, i: number)=>({...x, indicator: (i + 1).toString(), changeLineItem : applyToLineItem  })),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'isoCode', EditCell: IsoCodeRenderer },
      { accessor: 'countryName', EditCell: CountryNameRenderer },
      { accessor: 'usCode', EditCell: UsCodeRenderer },
    //  { accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'isoCode')
        return { type: TableCellTypes.Text, value: data[rowIndex].isoCode };
      else if (accessor === 'countryName')
       return { type: TableCellTypes.Text, value: data[rowIndex].countryName };
      else if (accessor === 'usCode')
        return { type: TableCellTypes.Text, value: data[rowIndex].usCode, align: TableCellAligns.Center};
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },
    orderBy: [orderBy],
    onHeaderClick,
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
    //useTableHelperText: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };

  //const canSelectForNew = ei === -1;
  const canBeAdd = listSec?.grantAdd;

  return (
    <div style={{ marginTop: '40px' }}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Region <FontAwesomeIcon icon={faAngleRight} />&nbsp;Country</h1>
        <div style={{width: '320px', fontWeight: 'bold'}}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={generalText1 => setOrderBy({general1: generalText1 ? orderBy?.orderBy : null, generalText1})} />
        </div>
      </Portal> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', width:'100px'}}>
          <div className="ifms-common-bar-element-center">
            <GreenButton size="regular" disabled={loading} onClick={save}><span style={{ textDecoration: 'underline' }}>S</span>ave</GreenButton>
          </div>
          <div style={{margin:'auto'}}></div>
          <div className="ifms-common-bar-element-center">
            <CloseButton onlyIcon name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
          {/* <div className="ifms-common-bar-element">
            <BlackInverseButton name='codes-currency-refresh-button' size="large" style={{marginTop: '-5px'}} disabled={loading} onClick={() => { reload(false); }} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div> */}
        </div>
      </Portal>

      {/* <div className="reference-codes-title-row"> */}
      {/* <div className="oi-doc-title-sub-row">

           <div style={{marginLeft: '10px', fontSize: '11px', fontWeight: 'bold'}}>
            Double Click Country to Edit
          </div> 
        </div> */}


      {/* <div style={{ width: '320px', fontWeight: 'bold' }}>
        <ClearableSearch
          initialValue={orderBy?.generalText1 || ''}
          onSearch={async generalText1 => {
            await reload(generalText1 === null ? '' : generalText1);
          }}
        />
      </div> */}
      <div style={{ display: 'flex', width: '432px' }}>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          {/* <SecondaryButton name='codes-country-add-button' size="regular" disabled={!canBeAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} /> &nbsp; Add Line</SecondaryButton> &nbsp; */}
          {/* <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(true); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton> */}
          <RefreshIconButton2 name='list-screen-refresh' onClick={() => { reload(true); }} disabled={loading} data-tooltip="Refresh"/>
        </div>
      </div>
      <div style={{ width: '432px' }}>
        {/* <SmartTable {...tableOptions} /> */}
        <EditableTable
          initializeFocusedCell={focusFirstCell}
          tableOptions={tableOptions}
          deleteLine={deleteEntity}
          addLine={addLineItem}
        />
      </div>
      {/* 250721.inhyung.issue#2570. Table 하단에 text 추가. */}
      <div style={{ marginTop: '6px', fontSize: '14px', color: '#000000' }}>
      To add item, press "Insert" Key in any row.<br />
      To delete item, press "Delete" Key on selected row.
    </div>
    </div>
  );
}

export default CountryComponent;
